import { render } from "./sidebarComponent.vue?vue&type=template&id=634f7242&scoped=true&ts=true"
import script from "./sidebarComponent.vue?vue&type=script&lang=ts"
export * from "./sidebarComponent.vue?vue&type=script&lang=ts"

import "./sidebarComponent.vue?vue&type=style&index=0&id=634f7242&scoped=true&lang=css"

import exportComponent from "/Users/rico/_repos/99v/trackyourgame/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634f7242"]])

export default __exports__